import React from 'react'

const PrivacyOfficerIcon = (
  <>
    <path
      d="M13.7115 1.46299L7.07995 0.0084545C7.02726 -0.00281817 6.97274 -0.00281817 6.92005 0.0084545L0.288474 1.46299C0.119737 1.50008 0 1.64772 0 1.81826V9.09095C0 12.9066 3.13416 16 7 16C10.8658 16 14 12.9066 14 9.09095V1.81826C14 1.64772 13.8803 1.50008 13.7115 1.46299Z"
      fill="url(#paint0_linear_3531_12144)"
    />
    <path
      d="M13.692 1.45648L7.06042 0.0019454C7.04016 0.000490858 7.02026 0.000490858 7 0.0019454V15.9924C10.8566 15.9779 13.9764 12.8899 13.9805 9.08335V1.81066C13.9801 1.64048 13.8604 1.49357 13.692 1.45648Z"
      fill="#3CB34B"
    />
    <path
      d="M9.94724 7.2727H8.84198V5.45452C8.84198 4.45053 8.01708 3.63635 6.99987 3.63635C5.98266 3.63635 5.15777 4.45053 5.15777 5.45452V7.2727H4.0525C3.84913 7.2727 3.68408 7.4356 3.68408 7.63633V11.2727C3.68408 11.4734 3.84913 11.6363 4.0525 11.6363H9.94724C10.1506 11.6363 10.3157 11.4734 10.3157 11.2727V7.63633C10.3157 7.4356 10.1506 7.2727 9.94724 7.2727ZM8.10513 7.2727H5.89461V5.45452C5.89461 4.85198 6.3894 4.36362 6.99987 4.36362C7.61035 4.36362 8.10513 4.85198 8.10513 5.45452V7.2727Z"
      fill="url(#paint1_linear_3531_12144)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3531_12144"
        x1="7"
        y1="0"
        x2="7"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6AD084" />
        <stop offset="1" stop-color="#3CB34B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3531_12144"
        x1="6.99987"
        y1="3.63635"
        x2="6.99987"
        y2="11.6363"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#D8F3E0" />
      </linearGradient>
    </defs>
  </>
)

export default PrivacyOfficerIcon
